import { Divider } from '@mui/material';
import { FaEnvelope, FaHouse, FaPhone } from 'react-icons/fa6';
import MenuLink from '~/components/layouts/MenuLink';
import { getLcn } from '~/utils/labeled-classnames';

const startsWith = (path: string) => window.location.pathname.startsWith(path);

export default function SidebarContent() {
  const lcn = getLcn({
    sidebarContent: 'md:my-4 flex flex-col ',
  });

  return (
    <div className={lcn.sidebarContent}>

      <MenuLink to={`/`} icon={<FaHouse />} > Home </MenuLink>
      <MenuLink to={`/meet`} icon={<FaPhone />} > Schedule a Meeting </MenuLink>
      <MenuLink to={`/pages/contact`} icon={<FaEnvelope />} > Contact </MenuLink>

      <Divider />

    </div>
  );
};
